import { LoadingIndicator, Button } from '@qga/roo-ui/components';
import styled from '@emotion/styled';

const OpaqueButton = styled(Button)`
  &:disabled {
    opacity: 1;
  }
`;

const ButtonWithLoadingIndicator = (props) => (
  <OpaqueButton {...props} bg="#870000" aria-label="Loading" aria-live="assertive">
    <LoadingIndicator color="white" size={21} />
  </OpaqueButton>
);

export default ButtonWithLoadingIndicator;
